import {
  CrmCustomerLearning,
  type CrmCustomerLearningFilters,
  type CrmCustomerLearningSection,
  type CrmCustomerLearningSort,
} from '@features/crm-customer-learning';
import { useCrmCustomerRecord } from '@widgets/crm-customer-record-shell';

export interface CrmCustomerLearningPageProps {
  attemptCursor?: string;
  attemptCursorHistory?: string[];
  filters: CrmCustomerLearningFilters;
  onAttemptCursorChange: (cursor: string | undefined, history: string[] | undefined) => void;
  onFiltersChange: (filters: CrmCustomerLearningFilters) => void;
  onOpenCertificationProfile: (certificationId: string) => void;
  onOpenEducationModuleLogProfile: (educationModuleLogId: string) => void;
  onOpenRegistrationProfile: (registrationId: string) => void;
  onPageChange: (page: number) => void;
  onSearchChange: (q: string | undefined) => void;
  onSectionChange: (section: CrmCustomerLearningSection) => void;
  onSortChange: (sort: CrmCustomerLearningSort) => void;
  onViewCourseRegistrations: (courseId: string) => void;
  onViewCourseProfile: (courseId: string) => void;
  onViewRegistrationDocuments: (registrationId: string) => void;
  onViewRegistration: (registrationNumber: string) => void;
  page: number;
  q?: string;
  section: CrmCustomerLearningSection;
  sort: CrmCustomerLearningSort;
}

export function CrmCustomerLearningPage(props: CrmCustomerLearningPageProps) {
  const record = useCrmCustomerRecord();

  return (
    <CrmCustomerLearning
      {...props}
      customerId={record.customer.customerId}
      viewerAccessScope={record.viewerAccessScope}
      onAuthorizationFailure={record.refreshAuthorization}
    />
  );
}
